const createData = (name: string, applicant: string, coAppicant: string) => {
  return {
    name,
    applicant,
    coAppicant,
  };
};

export const mockupRows = [
  createData('Gross income', '￡40,000', '￡30,000'),
  createData('Factored income', '￡20,000', '￡10,000'),
  createData('Net income', '￡60,000', '￡40,000'),
];
